import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#0A1535] border-t border-[#E0B756]/20 py-12 px-6" style={{
    backgroundColor: "#F7F2E7",
    backgroundImage: "none"
  }} data-id="element-101" data-mp="32wd2cf6gdjt0">
      <div className="max-w-4xl mx-auto text-center" data-id="element-102" data-mp="32o48c2sn9u2u">
        <h3 className="text-2xl font-bold text-[#E0B756] mb-4" style={{
        fontSize: "28px"
      }} data-id="element-103" data-mp="32pp4txyirn3c">
          Método R.E.V.E.L.A.
        </h3>
        <p className="text-gray-400 text-sm mb-4" style={{
        color: "#0A1535",
        fontWeight: "500"
      }} data-id="element-104" data-mp="3ufa4y995p9nd">
          30 Días con Dios para Vivir en Abundancia desde la Fe
        </p>
        <nav aria-label="Enlaces legales" className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mb-6" data-id="element-105" data-mp="36mrefh5qqqd">
          <a href="#terminos" className="text-gray-400 text-sm hover:text-[#E0B756] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#E0B756] rounded" data-id="element-106" data-mp="3qdf75eqfpeec">
            Términos y Condiciones
          </a>
          <span className="text-[#E0B756]/30" aria-hidden="true" data-id="element-107" data-mp="2ezbf4e3eq0bx">
            ·
          </span>
          <a href="#privacidad" className="text-gray-400 text-sm hover:text-[#E0B756] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#E0B756] rounded" data-id="element-108" data-mp="3lalgfg6ys7uh">
            Política de Privacidad
          </a>
          <span className="text-[#E0B756]/30" aria-hidden="true" data-id="element-109" data-mp="3v5n6ce92ddy4">
            ·
          </span>
          <a href="#derechos" className="text-gray-400 text-sm hover:text-[#E0B756] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#E0B756] rounded" data-id="element-110" data-mp="3qaq1ljithqr1">
            Derechos de Autor
          </a>
        </nav>

        <p className="text-gray-500 text-xs mb-6" data-id="element-111" data-mp="ht39rc2xh6vn">
          © {new Date().getFullYear()} Método R.E.V.E.L.A. Todos los derechos
          reservados.
        </p>

        <div className="border-t border-[#E0B756]/15 pt-6 max-w-2xl mx-auto" data-id="element-112" data-mp="cw36ta1dkk8r">
          <p className="text-gray-600 text-xs leading-relaxed" data-id="element-113" data-mp="qtrs2izcttec">
            Materiales digitales de uso personal e intransferible; queda
            prohibida su reproducción o reventa. Todo el contenido es propiedad
            de Método R.E.V.E.L.A. y está protegido por derechos de autor. Este
            programa es de naturaleza educativa y espiritual y no sustituye
            asesoría profesional; los resultados pueden variar. Compra segura a
            través de Hotmart con garantía de reembolso de 7 días.
          </p>
        </div>
      </div>
    </footer>;
}